var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"main-header"},[_vm._v("Activities")]),_c('ActivityTimeline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }